/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
  const pdp_form = document.querySelector('.ProductForm');
  const pre_order_container = pdp_form.querySelector('.pre-order-container');
  const pre_order_btn = pdp_form.querySelector('.ProductForm__AddToCart');
  const ships_date_container = pdp_form.querySelector('.ships-date-container');
  const final_sale_ships_date_container = pdp_form.querySelector('.final-sale-ships-date-container');

  var variant = event.detail.variant; // Gives you access to the whole variant details
  if (!variant) {
    pre_order_container.innerHTML = '';
    ships_date_container.innerHTML = '';
    final_sale_ships_date_container.innerHTML = '';
    return;
  }
  const v_info = window.product[variant.id];
  var pre_order_html = '';
  pre_order_container.innerHTML = pre_order_html;

  var today = new Date();
  var current_year = today.getFullYear();
  var current_month = today.getMonth() + 1;
  var current_date = today.getDate();

  if (variant.available) {

    if (v_info.pre_order_enabled == null) {
      pre_order_btn.innerHTML = 'Add To Cart';
      pre_order_btn.classList.add('Button--primary');
      pre_order_btn.classList.remove('Button--secondary');
      pre_order_btn.removeAttribute('disabled');
      pre_order_btn.setAttribute('data-action', 'add-to-cart');
    } else {
      pre_order_btn.classList.remove('Button--secondary');
      pre_order_btn.classList.add('Button--primary');
      pre_order_btn.innerHTML = 'Pre-Order Now';
      pre_order_btn.removeAttribute('disabled');
      pre_order_btn.setAttribute('data-action', 'add-to-cart');

      if (v_info.pre_order_enabled && v_info.pre_order_est_date) {

        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        shipping_est_date = new Date(v_info.pre_order_est_date).toLocaleDateString("en-US", options);

        pre_order_html = `
        <input type="hidden" id="pre-order-note" name="properties[PreOrder-Note]" value="Ships ${shipping_est_date}" />
        <label>Ships ${shipping_est_date}</label>`;

        pre_order_container.innerHTML = pre_order_html;
      }
    }
  } else {
    pre_order_btn.classList.remove('Button--primary');
    pre_order_btn.classList.add('Button--secondary');
    pre_order_btn.innerHTML = 'Sold Out';
    pre_order_btn.setAttribute('disabled', 'disabled');
    pre_order_btn.removeAttribute('data-action');
  }


  ships_date_container.innerHTML = v_info.ships_date ? `
    <input type="hidden" id="pre-order-note" name="properties[Ships]" value="${v_info.ships_date}">
    <div class="preorder-description">Ships ${v_info.ships_date}</div>
  ` : '';

  final_sale_ships_date_container.innerHTML = v_info.final_sale_date ? `
    <input type="hidden" id="pre-order-note" name="properties[Final-Sale]" value="Ships ${v_info.final_sale_date}">
    <div class="preorder-description">Final Sale: Ships ${v_info.final_sale_date}</div>
  ` : '';
});

// Accordion description fucnion //
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('ProductMeta__AccordionTitle')) {
      const field = event.target.closest('.ProductMeta__AccordionField');
      const isOpened = field.classList.contains('opened');
      field.classList.toggle('opened', !isOpened);
      field.classList.toggle('closed', isOpened);
    }
  });
});

if (!customElements.get('component-newsletter')) {
  class KlaviyoSubscribe extends HTMLElement {
    constructor() {
      super();
      this.list_id = this.dataset.listId;
      this.campaign_id = this.dataset.campaignId;
      this.dataset.klaviyo !== 'false' ? this.hasKlaviyo = true : this.hasKlaviyo = false;
      this.form = this.querySelector('form');
      this.input = this.form.querySelector('input[type="email"]');
      this.submit = this.form.querySelector('[type="submit"]');
      this.errorWrapper = this.form.querySelector('.email__error');
      this.error = this.form.querySelector('.error__text');
      this.success = this.form.querySelector('.email__input-success');
      this.wrapper = this.form.querySelector('.email__form-wrapper');
      this.companyId = 'LqrXyR';
      
      if (this.hasKlaviyo) {
        this.form.addEventListener('submit', this.klaviyoFormSubmit.bind(this));
      }
      
      this.input.addEventListener('input', () => this.hideError());
    }
    
    formData() {
      return {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Klaviyo form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.list_id}}}
          }
        })
      };
    }
    
    klaviyoFormSubmit(evt) {
      evt.preventDefault()
      
      if (this.list_id === '') {
        this.showError(window.newsletterStrings.klaviyoError);
      }
      
      console.log(this.inputValidation())
      if (!this.inputValidation()) return;
      
      const _this = this;
      
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
        .then(response => {
          (response.status === 202) ? _this.showSuccess() : _this.showError()
        })
        .catch(err => {
          console.error(err);
          _this.showError()
        });
    }
    
    showSuccess() {
      if (this.success) {
        this.success.setAttribute('aria-hidden', 'false');
        this.input.classList.add('disabled');
        this.input.blur();
        this.wrapper.classList.add('success');
        this.submit.setAttribute('disabled', 'true');
        
        if (this.campaign_id) {
          this.setCampaignCookie(this.campaign_id);
        }
      }
    }
    
    setCampaignCookie(name) {
      const days = 60; // 2 months roughly equals 60 days
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "; expires=" + date.toUTCString();
      document.cookie = `${name}=true` + expires + "; path=/";
      
      setTimeout(() => {
        document.querySelector(`.password-access[data-campaign="${this.campaign_id}"]`).classList.add('transition-hide')
      }, 1000)
      
      setTimeout(() => {
        document.querySelector(`#main`).classList.remove('hidden')
        document.querySelector(`.password-access[data-campaign="${this.campaign_id}"]`).classList.add('hidden')
        
        if (document.querySelector(`[data-section-type="recently-viewed-products"]`)) {
          Flickity.data(document.querySelector(`[data-section-type="recently-viewed-products"] .flickity-enabled`)).resize()
        }
      }, 1900)
    }
    
    
    hideError() {
      this.errorWrapper.setAttribute('aria-hidden', 'true');
      this.wrapper.classList.remove('error');
      this.submit.removeAttribute('disabled');
    }
    
    showError(errorText) {
      this.errorWrapper.setAttribute('aria-hidden', 'false');
      // check line below (was errorText = errorText ?? this.error.textContent;)
      errorText = errorText || this.error.textContent;
      this.error.textContent = errorText;
      this.wrapper.classList.remove('success');
      this.wrapper.classList.add('error');
      this.submit.setAttribute('disabled', 'true');
    }
    
    inputValidation() {
      const val = this.input.value;
      
      if (!val) return false;
      
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(val);
      
      if (result) {
        this.hideError();
        return true;
      } else {
        this.showError();
        return false;
      }
    }
  }
  
  customElements.define('component-newsletter', KlaviyoSubscribe);
}


/* ADD-ON SECTION */

if (!customElements.get('add-on')) {
  class AddOn extends HTMLElement {
    constructor() {
      super();
      this.addOnVariantId = null;
    }
    
    connectedCallback() {
      this.initOptionsToggle();
      this.initVariantChange();
    }
    
    initOptionsToggle() {
      const optionsOpeners = this.querySelectorAll('.ProductForm__AddOn__OptionsOpener');
      optionsOpeners.forEach((opener) => {
        opener.addEventListener('click', () => {
          const field = opener.closest('[data-add-on-options]');
          const isCurrentlyOpened = field.classList.contains('opened');
          
          this.querySelectorAll('[data-add-on-options]').forEach((f) => {
            f.classList.add('closed');
            f.classList.remove('opened');
          });
          
          if (!isCurrentlyOpened) {
            field.classList.add('opened');
            field.classList.remove('closed');
          }
          const priceElement = this.querySelector('[data-add-on-price]');
          
          priceElement.textContent = priceElement.getAttribute('data-add-on-first-price')
        });
      });
    }
    
    
    initVariantChange() {
      const addOnItems = this.querySelectorAll('[data-add-on-item]');
      addOnItems.forEach((item) => {
        const variantSelectors = item.querySelectorAll('.ProductForm__AddOn__OptionSelect');
        const currentOptionDisplay = item.querySelector('.ProductForm__AddOn__CurrentOption');
        const singleOptions = item.querySelectorAll('.ProductForm__AddOn__SingleOption');
        const addOnId = item.getAttribute('data-add-on-item');
        const checkbox = item.querySelector('[data-add-on-checkbox]');
        this.addOnVariantId = checkbox.value;
        
        const updateCurrentOptionsDisplay = () => {
          const selectedOptions = Array.from(variantSelectors).map((select) => select.options[select.selectedIndex].value);
          const fixedOptions = Array.from(singleOptions).map((singleOption) => singleOption.textContent.trim());
          const allOptions = [...fixedOptions, ...selectedOptions];
          
          const productJsonElement = document.querySelector(`#add-on-product-json-${addOnId}`);
          if (productJsonElement) {
            const productData = JSON.parse(productJsonElement.textContent);
            
            const selectedVariant = productData.variants.find((variant) => {
              const variantOptions = variant.options.join(" / ");
              const selectedOptionsString = allOptions.join(" / ");
              return variantOptions === selectedOptionsString;
            });
            
            if (selectedVariant) {
              
              const newPrice = selectedVariant.price;
              const oldPrice = selectedVariant.compareAtPrice;
              const priceElement = item.querySelector('[data-add-on-price]');
              const img = item.querySelector('.ProductForm__AddOn__Image__Wrapper img');
              const oldPriceElement = item.querySelector('[data-add-on-old-price]');
              
              if (selectedVariant.image) {
                img.src = selectedVariant.image;
              }
              if (priceElement && priceElement.textContent !== newPrice) {
                priceElement.textContent = newPrice;
                
                if (oldPrice && oldPriceElement) {
                  oldPriceElement.textContent = oldPrice;
                  oldPriceElement.style.display = 'block';
                } else if (oldPriceElement) {
                  oldPriceElement.style.display = 'none';
                }
              }
              this.addOnVariantId = selectedVariant.variantId;
              
              if (checkbox) {
                checkbox.value = this.addOnVariantId;
              }
            }
          }
          
          if (currentOptionDisplay) {
            currentOptionDisplay.textContent = allOptions.join(' / ');
          }
        };
        
        variantSelectors.forEach((select) => {
          select.addEventListener('change', updateCurrentOptionsDisplay);
        });
      });
    }
  }
  
  customElements.define('add-on', AddOn);
}
